import { SxProps } from "@mui/material";

export const headerBox: SxProps = {
  display: "flex",
  padding: "20px 16px",
  alignItems: "center",
  gap: "16px",
  justifyContent: "space-between",
};

export const bodyBox: SxProps = {
  display: "flex",
  padding: "0px 20px 20px",
  flexDirection: "column",
  gap: "40px",
};
export const empty_option: SxProps = {
  display: "flex",
  padding: "20px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "var(--Spacing-Spacing-16, 16px)",
  alignSelf: "stretch",
};
